"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconDoor = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M13.7777778,6.66666667 L13.7777778,20 L4,20 L4,18.2222222 L5.77777778,18.2222222 L5.77777778,4 L13.7777778,4 L13.7777778,4.88888889 L18.2222222,4.88888889 L18.2222222,18.2222222 L20,18.2222222 L20,20 L16.4444444,20 L16.4444444,6.66666667 L13.7777778,6.66666667 Z M10.2222222,11.1111111 L10.2222222,12.8888889 L12,12.8888889 L12,11.1111111 L10.2222222,11.1111111 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconDoor')(IconDoor);